import { Dropdown } from "@components/ui/Dropdown"
import { useCurrency } from "@lib/hooks/use-currency"
import React, { FC } from "react"
import { NavbarCurrencyButton } from "./CurrencyButton"
import { CurrencyDropdown } from "./CurrencyDropdown"

export const CurrencyDropdownMenu: FC = () => {
  const { currency, setCurrency } = useCurrency()

  return (
    <Dropdown
      trigger={<NavbarCurrencyButton currency={currency} />}
      modal={false}
      align="center"
    >
      <CurrencyDropdown selectedCurrency={currency} onSelect={setCurrency} />
    </Dropdown>
  )
}
